export default __webpack_public_path__ + "static/media/Tissue-3-2.248c2372.png";